module.exports = __webpack_public_path__ + "static/media/bill.1f5cdd2b.jpg";